import { SET_LANGUAGE } from '../actions/actionTypes'

export default function reducer(state = {}, action: any) {
    switch(action.type) {
        case SET_LANGUAGE:
	        let stateLocation = action.payload.stateLocation;
            return Object.assign({}, state, {
                [stateLocation]: action.payload.language
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./modules/custom-language-watcher/reducers/reducers.ts